// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2-mtC","footer":"ReportModalFilter_footer__HqFzC"};